var cardShipping = $(".card-shipping");
var homeShipping = $( "#homeShipping");
var relaisColisShipping = $( "#relaisColisShipping");
var colissimoShipping = $( "#colissimoShipping");
var homeShippingForm = $("#homeShippingForm");
var relaisColisShippingForm = $("#relaisColisShippingForm");
var colissimoShippingForm = $("#colissimoShippingForm");
var shippingForm = $(".shippingForm");
var shippingFormBtn = $(".shippingFormBtn");
var radioHome = $("#inlineRadio3");
var radioCustomAddress1 = $("#inlineRadio4");
var radioCustomAddress1Form = $("#radioCustomAddress1Form");

$(cardShipping).click(function() {
    $(cardShipping)
        .not(this)
        .removeClass("bg-dark-2")
        .removeClass("text-white")
        .removeClass("active-card");

    $(this)
        .addClass("bg-dark-2")
        .addClass("text-white")
        .addClass("active-card");
});

$(homeShipping).click(function() {
    $(homeShippingForm).removeClass("hide");
    $(homeShippingForm).addClass("show");
    $(shippingForm).not(homeShippingForm).removeClass("show");
    $(shippingForm).not(homeShippingForm).addClass("hide");
});

$(relaisColisShipping).click(function(e) {
    $(relaisColisShippingForm).removeClass("hide");
    $(relaisColisShippingForm).addClass("show");
    $(shippingForm).not(relaisColisShippingForm).removeClass("show");
    $(shippingForm).not(relaisColisShippingForm).addClass("hide");
    $('.next-step').prop('disabled', true);
});

$(colissimoShipping).click(function(e) {
    e.preventDefault();

    var $btn = jQuery(this);

    if ($btn.prop("disabled")) {
        return;
    }

    $btn.prop("disabled", true);

    setTimeout(function () {
        $btn.prop("disabled", false);
    }, 2500);

    $(colissimoShippingForm).removeClass("hide");
    $(colissimoShippingForm).addClass("show");
    $(shippingForm).not(colissimoShippingForm).removeClass("show");
    $(shippingForm).not(colissimoShippingForm).addClass("hide");
    $('.next-step').prop('disabled', false);
    $('.next-step').addClass('hide');
    $('.next-step:first').click();
});

$(radioHome).change(function() {
    $(radioCustomAddress1Form).removeClass("show");
    $(radioCustomAddress1Form).addClass("hide");
});

$(radioCustomAddress1).change(function() {
    $(radioCustomAddress1Form).addClass("show");
    $(radioCustomAddress1Form).removeClass("hide");
});
